// extracted by mini-css-extract-plugin
export default {"root":"JournalManage_root__ksbM5"};